import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "PILOT_TRANSPORT_CONTACT_ADMIN",
        applicationRights: Rights,
        title: 'Tilbringeradmin',
        text: 'Tilbringeradmin',
        icon: 'address-book',
        showOnDashboardByDefault: false,
        url: "/transport-contacts-admin",
        routes: Routes
})
